import { useCallback, useState } from "react";
import { useMutation } from '@apollo/client';
import { LanguageI18nKey } from "Services/Api/Common/Types";
import { ID_BY_LANGUAGE } from "i18n/i18n.constants";
import { Notification } from 'Components';
import { UPDATE_CURRENT_USER } from 'Services/Api/Auth/Mutations';

const useLanguageChange = ({
    authStore,
    languageStore
}: any) => {
    const [loading, setLoading] = useState(false);
    const [updateCurrentUser] = useMutation(UPDATE_CURRENT_USER);

    const handleLanguageChange = useCallback(
        async ({ key }: { key: string }) => {
            try {
                const language = key as LanguageI18nKey;
                if (authStore.isAuthenticated) {
                    const languageId = ID_BY_LANGUAGE[language];
                    if (authStore.currentUser?.language?.id !== Number(languageId)) {
                        setLoading(true);
                        await updateCurrentUser({ variables: { input: { languageId } }});
                        await authStore.getCurrentUser();
                    }
                } else await languageStore.changeLanguage(language);
            } catch (error) {
                Notification.error({ description: (error as Error).message });
            } finally {
                setLoading(false);
            }
        },
        [authStore, languageStore, updateCurrentUser]
    );

    return { loading, handleLanguageChange };
};

export default useLanguageChange;